import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import welcomeBlockData from '../../../Models/Content/welcomeBlockData';
import Welcome from './welcome';

export default class welcomeBlock extends EpiComponent<welcomeBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return <Welcome context={this.getContext()} contentData={this.props.data} />;
  }
}
